<template>
  <el-select v-model="senid" :placeholder="placeholder" filterable clearable @change="handleSenSelectChanged">
    <el-option v-for="item in sens" :key="item.senid" :label="item.sen_name" :value="item.senid">
      <div class="flex align-items-center">
        <img v-if="item.icon_url" :src="item.icon_url" class="s-icon hd" />
        <div v-else class="s-icon hd"></div>
        <span class="ml-sm bd">{{ item.sen_name }}</span>
        <div class="ft ml font-sm text-muted">{{ senAccessObj[item.sen_rw].title }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SenSelector',

  props: {
    value: {
      type: [Number, String],
      default: 0,
    },

    sens: {
      type: Array,
      default: []
    },

    placeholder: {
      type: String,
      default: ''
    },
  },

  computed: {
    ...mapGetters([
      'senAccessObj'
    ]),

    senid: {
      get () {
				return this.value ? this.value : null
			},
			set (val) {
				val = val ? val : null
				this.$emit('input', val)
			}
    }
  },

  methods: {
    handleSenSelectChanged(item) {
      this.$emit('change', item)
    }
  }

}
</script>

<style>
.s-icon {
  height: 20px;
  width: 20px;
  background-color: transparent;
}
</style>
